import { ISmartStorageProviderV2, StorageProvider } from '../StorageProvider.ts';

export class TrackingStorageProvider {
    static inject = () => [StorageProvider];
    constructor(storageProvider: StorageProvider){
        this.optOutOfTracking = storageProvider.getBooleanProvider('OPT_OUT_TRACKING_V2', { envNeutral: true, userNeutral: true, storageType: 'localStorage' });
    }

    // NOTE: old storage key OPT_OUT_TRACKING is deprecated and ignored
    optOutOfTracking: ISmartStorageProviderV2<boolean>;
}
